"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _SettingsActions = require("../actions/SettingsActions");

var _StagingActions = require("../actions/StagingActions");

var _settingsSelectors = require("../selectors/settingsSelectors");

var _domainsSelectors = require("../selectors/domainsSelectors");

var _SettingsAPI = _interopRequireDefault(require("../api/SettingsAPI"));

var _DomainsAPI = _interopRequireDefault(require("../api/DomainsAPI"));

var _DomainsActions = require("../actions/DomainsActions");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _multiRequestEpic = _interopRequireDefault(require("settings-ui-sdk/multiRequestEpic"));

var _requestStatusSelectors = require("../selectors/requestStatusSelectors");

var updateSettingsEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _SettingsAPI.default.put,
  initiatingActionType: _SettingsActions.SettingsActionTypes.SAVE_SETTINGS,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _SettingsActions.SaveSettings
}));
var deleteDomainEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _DomainsAPI.default.delete,
  initiatingActionType: _DomainsActions.DomainsActionTypes.DELETE_DOMAIN,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _DomainsActions.DeleteDomain
}));
var addDomainEpic = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _DomainsAPI.default.put,
  initiatingActionType: _DomainsActions.DomainsActionTypes.ADD_DOMAIN,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _DomainsActions.AddDomain
}));
var saveStagedChangesEpic = (0, _multiRequestEpic.default)({
  requestEpics: [addDomainEpic, deleteDomainEpic, updateSettingsEpic],
  mapStateToInitiatingActions: function mapStateToInitiatingActions(state) {
    return [].concat((0, _toConsumableArray2.default)((0, _domainsSelectors.getStagedAddDomains)(state).map(function (stagedAddDomain) {
      return (0, _DomainsActions.addDomain)(stagedAddDomain.domain);
    }).toJS()), (0, _toConsumableArray2.default)((0, _domainsSelectors.getStagedRemoveDomains)(state).map(function (stagedRemoveDomain) {
      return (0, _DomainsActions.deleteDomain)(stagedRemoveDomain.domain);
    }).toJS()), [(0, _SettingsActions.saveSettings)((0, _settingsSelectors.getStagedSettings)(state).toJS())]);
  },
  metaInitiatingActionType: _StagingActions.StagingActionTypes.SAVE_STAGED_CHANGES,
  metaRequestStatusSelector: _requestStatusSelectors.getSaveStagedChangesRequestStatus,
  metaRequestActions: _StagingActions.SaveStagedChanges
});
var _default = saveStagedChangesEpic;
exports.default = _default;
module.exports = exports.default;